import { makeStyles } from '@material-ui/core'

import helpers from 'helpers'
import constants from 'constants/index'

const styles = ({ secondaryColor, previewMode, isFixed, isTop, screenScale }) =>
  makeStyles((theme) => {
    const {
      DESKTOP_PREVIEW_HEIGHT,
      DESKTOP_PREVIEW_WIDTH,
      MOBILE_PREVIEW_HEIGHT,
      MOBILE_PREVIEW_WIDTH,
      PREVIEW_MODES,
    } = constants.cookies.banner

    const isBannerMode = previewMode === PREVIEW_MODES.BANNER
    const isDesktop = previewMode === PREVIEW_MODES.DESKTOP
    const isMobile = previewMode === PREVIEW_MODES.MOBILE

    const sidePadding = isFixed && isMobile ? 0 : 16
    // As superiores espelham as inferiores: 24px do topo, como no site
    const screenPadding = isBannerMode
      ? 0
      : isTop
      ? `24px ${sidePadding}px ${isFixed ? 0 : 16}px`
      : isFixed
      ? `0 ${sidePadding}px 24px`
      : '16px 16px 24px'

    return {
      root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
      },
      previewArea: {
        flex: 1,
        minHeight: MOBILE_PREVIEW_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      frame: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: isBannerMode ? 'stretch' : undefined,
        width: '100%',
        maxWidth: isMobile ? MOBILE_PREVIEW_WIDTH : 'none',
        height: isMobile ? MOBILE_PREVIEW_HEIGHT : 'auto',
        boxSizing: 'border-box',
        overflow: isBannerMode ? 'visible' : 'hidden',
        backgroundColor: isBannerMode ? 'transparent' : theme.palette.grey[50],
        border: isBannerMode
          ? 0
          : `${isMobile ? 8 : 1}px solid ${theme.palette.grey[300]}`,
        borderRadius: isMobile ? 36 : 12,
      },
      phoneSpeaker: {
        alignSelf: 'center',
        flexShrink: 0,
        width: 64,
        height: 6,
        marginTop: 10,
        borderRadius: 3,
        backgroundColor: theme.palette.grey[300],
      },
      screen: {
        position: 'relative',
        overflow: isBannerMode ? 'visible' : 'hidden',
        flex: isDesktop ? 'none' : 1,
        height: isDesktop ? DESKTOP_PREVIEW_HEIGHT * screenScale : undefined,
      },
      screenContent: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: isDesktop ? DESKTOP_PREVIEW_WIDTH : '100%',
        height: isDesktop ? DESKTOP_PREVIEW_HEIGHT : '100%',
        boxSizing: 'border-box',
        padding: screenPadding,
        transform: isDesktop ? `scale(${screenScale})` : 'none',
        transformOrigin: '0 0',
      },
      cookieButton: {
        width: 56,
        height: 56,
        backgroundColor: helpers.palette.hexToRgba(secondaryColor, 0.12),
        color: secondaryColor,
        '&:hover': {
          backgroundColor: helpers.palette.hexToRgba(secondaryColor, 0.18),
        },
      },
      cookieIcon: {
        width: 40,
        height: 40,
        fontSize: 40,
      },
    }
  })

export default styles
